<template>
    <Modal id="search-modal"
           size="lg">
        <template v-slot:header>
            <div class="modl-header">
                <ModalTabs :tabs="tabs"
                           :selected-tab="selectedTab"
                           @select-tab="selectTab"></ModalTabs>
            </div>
        </template>

        <template v-slot:body>
            <component :is="selectedTab.component"
                       ref="current-tab-component"
                       @cancel="cancel"
                       @resolve="resolve" />
        </template>
    </Modal>
</template>

<script>
import CheckClubcardTokenTab from '@/epos/vue/modals/Search/CheckClubcardTokenTab';
import CheckCouponCodeTab from '@/epos/vue/modals/Search/CheckCouponCodeTab';
import CheckDtVoucherTab from '@/epos/vue/modals/Search/CheckDtVoucherTab';
import CheckProductSearchTab from '@/epos/vue/modals/Search/CheckProductSearchTab';
import ItemType from '@/lib/Items/ItemType';
import Modal from '@/vue/components/Modals/Modal';
import ModalTabs from '@/vue/components/Modals/ModalTabs';
import PaymentMethodRef from '@/lib/PaymentMethods/PaymentMethodRef';
import { container } from '@/container';
import { mapState } from 'vuex';
import { ModalPropsMixin } from '@/vue/mixins/ModalPropsMixin';
import { TabbedModalMixin } from '@/vue/mixins/TabbedModalMixin';

export default {
    components: {
        Modal,
        ModalTabs,
        CheckClubcardTokenTab,
        CheckCouponCodeTab,
        CheckDtVoucherTab,
        CheckProductSearchTab,
    },

    mixins: [
        ModalPropsMixin,
        TabbedModalMixin,
    ],

    data() {
        return {
            tabs: [],
        };
    },

    computed: {
        ...mapState('cartOffers', [
            'couponsCount',
        ]),
    },

    created() {
        const getAllSearchData = container.saleableItemService.itemTypes;
        if (getAllSearchData[ItemType.GIFT_VOUCHER].count) {
            this.tabs.push(
                {
                    name: 'dt-gift-voucher',
                    icon: 'fa-gift',
                    label: 'SEARCH_MODAL.GIFT_VOUCHER_TAB_NAME',
                    mobileLabel: 'SEARCH_MODAL.GIFT_VOUCHER_TAB_NAME_MOBILE',
                    component: 'CheckDtVoucherTab',
                }
            );
        }
        if (this.couponsCount) {
            this.tabs.push(
                {
                    name: 'coupon-codes',
                    icon: 'fa-tags',
                    label: 'CART_OFFERS.OFFER_CODES_TAB_TITLE',
                    mobileLabel: 'SEARCH_MODAL.OFFER_CODES_TAB_NAME_MOBILE',
                    component: 'CheckCouponCodeTab',
                }
            );
        }
        // Add the Clubcard UK tab only if the device/company has Clubcard UK enabled.
        if (container.paymentMethodService.getByRef(PaymentMethodRef.TESCO_VOUCHER_UK)) {
            this.tabs.push(
                {
                    name: 'clubcard',
                    icon: 'fa-rectangle-barcode',
                    label: 'SEARCH_MODAL.CLUBCARD_TOKEN_TAB_NAME',
                    mobileLabel: 'SEARCH_MODAL.CLUBCARD_TOKEN_TAB_NAME_MOBILE',
                    component: 'CheckClubcardTokenTab',
                },
            );
        }
        if (getAllSearchData[ItemType.PRODUCT].count || getAllSearchData[ItemType.PRODUCT_FOOD].count) {
            this.tabs.push(
                {
                    name: 'product-search',
                    icon: 'fa-search',
                    label: 'SEARCH_MODAL.PRODUCT_SEARCH',
                    mobileLabel: 'SEARCH_MODAL.PRODUCT_SEARCH_TAB_NAME_MOBILE',
                    component: 'CheckProductSearchTab',
                },
            );
        }

        if (this.tabs.length > 0 && !this.selectedTab) {
            this.selectTab(this.tabs[0]);
        }
    },
};
</script>

<style lang="less">
@import (reference) "../../../../less/variables";
    #search-modal .cart-offers-code-search {
        @media (min-width: @screen-md) {
            form .input-group-flex input ~ button:first-of-type{
                width: 120px;
            }
        }
    }
</style>
